@if (isLoading()) {
  <aw-loading-animation
    [entityType]="EEntityType.ticketConfiguration"
    [relationType]="
      ERelationType.loadingDirectTicketCheckout
    "></aw-loading-animation>
}
@if (ticketConfiguration() && currentProduct() && productForms.valid) {
  @let personalData = personalDataForm.value;
  @let userData = userDto();
  <div class="flex w-full flex-row gap-6">
    <div class="flex w-full flex-col gap-4 md:w-2/3">
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'checkout-payment-address-section'"
        class="flex w-full flex-col gap-4">
        <aw-section-headline>
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.paymentAddress
                : EEntityType.directTicket
              | language
          }}</aw-section-headline
        >
        <div class="text-base" [attr.data-testid]="'checkout-payment-address'">
          @if (userData) {
            <span [attr.data-testid]="'checkout-payment-address-name'"
              >{{ userData.firstName }} {{ userData.lastName }}</span
            ><br />
            <span [attr.data-testid]="'checkout-payment-address-street'"
              >{{ userData.address.street }} {{ userData.address.houseNumber }}
              {{ userData.address.additional }}</span
            >
            <br />
            <span [attr.data-testid]="'checkout-payment-address-city'"
              >{{ userData.address.postCode }} {{ userData.address.city }}</span
            >
            <br />
            <span [attr.data-testid]="'checkout-payment-address-country'">{{
              userData.address.country
            }}</span>
          } @else {
            <span [attr.data-testid]="'checkout-payment-address-name'"
              >{{ personalData.firstName }} {{ personalData.lastName }}</span
            ><br />
          }
        </div>
      </aw-section>
      <div>
        <aw-section
          [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
          [testIdAffix]="'checkout-email-section'"
          class="flex w-full flex-col gap-4">
          <aw-section-headline>
            {{
              textStore.texts()
                | filterTexts: ERelationType.email : EEntityType.loginLogout
                | language
            }}</aw-section-headline
          >
          <div class="text-base" [attr.data-testid]="'checkout-email'">
            {{ userData ? userData.email : personalData.email }}
          </div>
        </aw-section>
        @if (userData) {
          <div
            class="px-6 pt-2 text-sm"
            [attr.data-testid]="'checkout-private-data-hint'">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.privateDataHint
                  : EEntityType.directTicket
                | language
            }}
          </div>
        }
      </div>
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'checkout-payment-type-section'"
        class="flex w-full flex-col gap-4">
        <aw-section-headline>
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.paymentType
                : EEntityType.directTicket
              | language
          }}</aw-section-headline
        >
        @let paymentProvider =
          configurationStore.getEnumConfiguration(
            CONFIGURATION_SETTING_KEYS.PaymentProvider,
            EPaymentProviders
          );

        <div
          class="text-base"
          [attr.data-testid]="'checkout-no-payment-type-text'"
          [innerHTML]="
            textStore.texts()
              | filterTexts
                : ERelationType.noPaymentType
                : EEntityType.directTicket
              | language
          "></div>
      </aw-section>
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'checkout-payment-provider-section'"
        class="flex w-full flex-col gap-4">
        <aw-section-headline>
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.paymentProvider
                : EEntityType.directTicket
              | language
          }}</aw-section-headline
        >
        <div
          class="text-base"
          [attr.data-testid]="'checkout-payment-provider-text'">
          {{
            paymentProvider ??
              (textStore.texts()
                | filterTexts
                  : ERelationType.defaultPaymentProvider
                  : EEntityType.ticketConfiguration
                | language)
          }}
        </div>
        <div
          class="text-base"
          [attr.data-testid]="'checkout-no-payment-provider-text'"
          [innerHTML]="
            textStore.texts()
              | filterTexts
                : ERelationType.paymentProviderInfo
                : EEntityType.directTicket
              | language
          "></div>
      </aw-section>
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'checkout-receive-ticket-section'"
        class="flex w-full flex-col gap-4">
        <aw-section-headline>
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.receiveTicket
                : EEntityType.directTicket
              | language
          }}</aw-section-headline
        >
        <div
          class="text-base"
          [attr.data-testid]="'checkout-receive-ticket-text'"
          [innerHTML]="
            textStore.texts()
              | filterTexts
                : ERelationType.receiveTicketInfo
                : EEntityType.directTicket
              | language
          "></div>
      </aw-section>
    </div>
    <aw-direct-ticket-configuration-shopping-cart
      class="fixed bottom-0 left-0 z-20 w-full md:relative md:w-1/3"
      [page]="EPage.Configuration"
      [attr.data-testid]="'checkout-page-shopping-cart'"
      [isDisabled]="!personalDataForm.valid"
      (onButtonClick)="
        proceedToPayment()
      "></aw-direct-ticket-configuration-shopping-cart>
  </div>
}
<div class="pt-6 text-sm" [attr.data-testid]="'checkout-fine-print'">
  {{
    textStore.texts()
      | filterTexts: ERelationType.finePrint : EEntityType.directTicket
      | language
  }}
</div>
